(function() {
    window.c24.lp.ac.inv = {

        init: function() {

            $('.mod24ac.inv .option-optiona').on('click', function() {

                const ac = $(this).closest('.mod24ac');
                const radio = $('.option-optiona input[type=radio]', ac);
                const url = radio.attr('data-url');

                $('.box24FormAV', ac).attr('action', url);
                $('.option-optionb', ac).removeClass('selected');
                $('.option-optiona', ac).addClass('selected');

                radio.prop('checked', true);
            });

            $('.mod24ac.inv .option-optionb').on('click', function() {

                const ac = $(this).closest('.mod24ac');
                const radio = $('.option-optionb input[type=radio]', ac);
                const url = radio.attr('data-url');

                $('.box24FormAV', ac).attr('action', url);
                $('.option-optiona', ac).removeClass('selected');
                $('.option-optionb', ac).addClass('selected');

                radio.prop('checked', true);
            });
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.inv.init();
    });
})();
